import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Mounted once inside <BrowserRouter>, alongside the routed app (not inside
// it), so it sees every navigation regardless of which app tier (public vs.
// portal) or nested route matched. Without this, React Router preserves
// scroll position across route changes, so clicking a nav/menu item lands the
// new page wherever the previous page had scrolled to instead of at the top.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}
